// @flow
import React from 'react';

import {
  DownloadLinksList,
  type DownloadLinksListItem,
} from 'Components/frameworks/download-links-list/DownloadLinksList';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

type Props = {
  id?: string,
  links: Array<DownloadLinksListItem>,
  text?: string,
};

export const DownloadLinksListLine = ({ id, links = [], text }: Props) => {
  if (!links.length) {
    return null;
  }

  return (
    <SiteContainer className="Line Line-DownloadLinksList" id={id}>
      <DownloadLinksList className="bg-white py-5 shadow-bottom" links={links} text={text} />
    </SiteContainer>
  );
};
